import { baseReducer as BaseReducer } from '../../../store/core/base-reducer';

import * as Actions from './customers.create-label.actions';

const emptyConfigureRatesModel = {
  shipFromId: '',
  shipToCountryCode: '',
  shipToPostalCode: '',
  weight: {
    weightUnit: 'Ounces',
    weight: 0,
  },
  dimensions: {
    unit: 'Unknown',
  },
  confirmationType: '0',
  serviceClassificationId: '',
  isResidential: true,
};

const initialState = {
  configureRatesModel: emptyConfigureRatesModel,
  isModalOpen: false,
};

const actionHandlerMap = {
  [Actions.CLOSE_CUSTOMERS_CREATE_LABEL_MODAL]: () => initialState,
  [Actions.LAUNCH_CUSTOMERS_CREATE_LABEL_MODAL]: (state) => {
    return {
      ...state,
      isModalOpen: true,
    };
  },
  [Actions.CUSTOMER_CREATE_LABEL_CONFIGURE_RATES_MODEL]: (state, { updatePayload }) => {
    return {
      ...state,
      configureRatesModel: {
        ...state.configureRatesModel,
        ...updatePayload,
      },
    };
  },
  [Actions.UPDATE_CUSTOMER_CREATE_LABEL_FROM_SHIP_FROM_ID]: (state, { shipFromId }) => {
    return {
      ...state,
      configureRatesModel: {
        ...state.configureRatesModel,
        shipFromId,
      },
    };
  },
};

export const ConnectedActionHandlerMap = BaseReducer(initialState, actionHandlerMap);

export { namespace } from './customers.create-label.reducer.metadata';
